import type { ReactNode } from 'react';

import type { ActionMenuItem } from '@rover/components/src/callouts/ActionMenu/ActionMenu.common';
import { isReactNative } from '@rover/rsdk/src/modules/Network/userAgent';

import type { BulkPrivacyChange } from './hooks/useGalleryManageMode';
import type { GalleryItem, PaginationConfig } from './ImageGallery.common';
import ImageGridCloseButton from './ImageGridCloseButton';
import ManagedGalleryGrid from './ManagedGalleryGrid';

type ImageGridProps = {
  images: GalleryItem[] | undefined;
  onClose: () => void;
  onImageClick: (index: number) => void;
  pagination?: PaginationConfig;
  renderImageOverlay?: (index: number) => ReactNode;
  renderImageActions?: (index: number) => ActionMenuItem[];
  /** Native only. See `ImageGridContainer.native`. */
  virtualizedGrid?: boolean;
  /** Native virtualized grids only: pin the close button over the scrolling list. */
  floatingCloseButton?: boolean;
  dimmedImageIds?: Set<number>;
  lockedImageIds?: Set<number>;
  isViewingOwnGallery?: boolean;
  onBulkPrivacyChange?: BulkPrivacyChange;
  gridHeader?: ReactNode;
};

const ImageGrid = ({
  images,
  onClose,
  onImageClick,
  pagination,
  renderImageOverlay,
  renderImageActions,
  virtualizedGrid,
  floatingCloseButton,
  dimmedImageIds,
  lockedImageIds,
  isViewingOwnGallery,
  onBulkPrivacyChange,
  gridHeader,
}: ImageGridProps): JSX.Element => (
  <ManagedGalleryGrid
    contrast
    images={images}
    onImageClick={onImageClick}
    onClose={onClose}
    pagination={pagination}
    renderImageOverlay={renderImageOverlay}
    renderImageActions={renderImageActions}
    virtualizedGrid={virtualizedGrid}
    floatingCloseButton={floatingCloseButton}
    dimmedImageIds={dimmedImageIds}
    lockedImageIds={lockedImageIds}
    isViewingOwnGallery={isViewingOwnGallery}
    onBulkPrivacyChange={onBulkPrivacyChange}
    gridHeader={gridHeader}
    headerEnd={!isReactNative() ? <ImageGridCloseButton onClick={onClose} /> : undefined}
  />
);

export default ImageGrid;
